import React, { useEffect } from "react";
import {Trash} from 'react-bootstrap-icons';

function Guantes () {

  const Transforma = ({ values }) => {
    return (
      <>
        {values.map((genre, idx) => {
          return (
            <span key={idx} className="badge">
              {genre}
            </span>
          );
        })}
      </>
    );
  };

  useEffect(() => {
    console.log('se ejecuta useeffect Guante--> ');
    
  });

  const datos = [
    {
      marca: 'Salisbury',
      modelo: 'consultar',
      largo: '280',
      clase: '0',
      max_i_fuga: '5'
    },
    {
        marca: 'Novax',
        modelo: 'consultar',
        largo: '360',
        clase: '4',
        max_i_fuga: '5'
      },
      {
        marca: 'Chance',
        modelo: 'consultar',
        largo: '280',
        clase: '4',
        max_i_fuga: '5'
      },
      {
        marca: 'Regeltex',
        modelo: 'consultar',
        largo: '410',
        clase: '0',
        max_i_fuga: '6'
      },
      {
        marca: 'Salisbury',
        modelo: 'consultar',
        largo: '360',
        clase: '4',
        max_i_fuga: '5'
      },
      {
        marca: 'Novax',
        modelo: 'consultar',
        largo: '410',
        clase: '3',
        max_i_fuga: '5'
      },
      {
        marca: 'Otra',
        modelo: 'consultar',
        largo: '280',
        clase: '0',
        max_i_fuga: '5'
      },
  ];

  const columnas = [
    {
      Header: 'marca',
      accessor: 'marca'
    }, {
      Header: 'modelo',
      accessor: 'modelo'
    }, {
      Header: 'largo',
      accessor: 'largo',
      //Cell: ({ cell: { value } }) => {return (<><Trash />{value}</>)}
    }, {
      Header: 'clase',
      accessor: 'clase'
    }, {
      Header: 'max_i_fuga',
      accessor: 'max_i_fuga'
    }
  ];

  const titulo="Tipos de Guante";
  const botonAgregar = "guante";

  return {
    columnas,
    datos,
    titulo,
    botonAgregar,
  };
};

export default Guantes;